import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { usePwaUpdate } from "@/lib/pwa/use-pwa-update";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  usePwaUpdate();

  return (
    <TooltipProvider>
      <Outlet />
      <Toaster position="top-right" />
    </TooltipProvider>
  );
}
